import React from "react";

const FullCircleChart = ({ value = 32, size = 140 }) => {
  const safeValue = isNaN(value) ? 0 : value;
  const maxHours = 40;
  const strokeWidth = size * 0.1;
  const radius = size / 2;
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = 2 * Math.PI * normalizedRadius;

  const percent = Math.min(safeValue / maxHours, 1);
  const strokeDashoffset = circumference - percent * circumference;

  let chartColor = "#32CD32";
  if (safeValue <= 5) chartColor = "#DC143C";
  else if (safeValue > 5 && safeValue < 20) chartColor = "#FFBF00";

  const fontSize = size * 0.3;
  const text = `${safeValue}`;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {/* Background circle */}
      <circle
        cx={radius}
        cy={radius}
        r={normalizedRadius}
        fill="none"
        stroke="#e6e6e6"
        strokeWidth={strokeWidth}
      />

      {/* Progress circle */}
      <circle
        cx={radius}
        cy={radius}
        r={normalizedRadius}
        fill="none"
        stroke={chartColor}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
        transform={`rotate(-90 ${radius} ${radius})`}
      />

      {/* Centered bold text inside the circle */}
      <text
        x={radius}
        y={radius}
        textAnchor="middle"
        fontFamily="sans-serif"
        fontSize={fontSize}
        fontWeight="bold"
        fill="#000"
        dominantBaseline="middle"
      >
        {text}
      </text>
    </svg>
  );
};

export default FullCircleChart;
